import Box from "@mui/material/Box";
import { useRecoilValue } from "recoil";
import { cbErrorSectionValidationState } from "../state/customerbaseState";

interface CBAccordionTitleProps {
    section?: 'cbDetails' | 'cbPersonalOrganizationInfo' | 'cbInvoicingAddress' | 'salesAreas' | 'cbPaymentInfo' | 'cbCorporateInfo',
    label: string
}
const CBAccordionTitle = ({section, label}: CBAccordionTitleProps) => {

    const isErrorSectionValidation = useRecoilValue(cbErrorSectionValidationState);
    
    return (
        <Box 
            sx={{color: !!section && isErrorSectionValidation[section] ? "red" : "black"}}
        >
            {label}
        </Box>
            
    );

}

export default CBAccordionTitle;